import { UserInvoiceDetailSerializer } from "../../data/types/invoice";
import { TeakRefundProtectionClaim } from "./Teak/TeakRefundProtectionClaim.web";

type RefundProtectionClaimProps = {
  provider: "Teak" | "";
  transactionId: UserInvoiceDetailSerializer["transaction_id"];
  protection: UserInvoiceDetailSerializer["protection"];
  basketId: number;
  uuid1: string;
  uuid2: string;
  isBasketClaimed: boolean;
  withActionButtons?: boolean;
};

export function RefundProtectionClaim({
  provider,
  transactionId,
  protection: _protection,
  basketId,
  uuid1,
  uuid2,
  isBasketClaimed,
  withActionButtons = true,
}: RefundProtectionClaimProps) {
  if (provider === "Teak" && typeof transactionId === "string") {
    return (
      <TeakRefundProtectionClaim
        transactionId={transactionId}
        basketId={basketId}
        uuid1={uuid1}
        uuid2={uuid2}
        isBasketClaimed={isBasketClaimed}
        withActionButtons={withActionButtons}
      />
    );
  }

  return null;
}
